import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/rooms')({
  beforeLoad: async ({ context }) => {
    if (!context.authStore?.user?.isGeneratorAdmin)
      throw redirect({ replace: true, to: '/' })
  }
})
